import { useContext } from 'react';
import { createContext } from 'react';

import { WishlistProps } from '../@types/WishlistProps';

export const WishlistContext = createContext<WishlistProps>({} as WishlistProps);

WishlistContext.displayName = 'Wishlist';

const WishlistProvider = (props: WishlistProps) => (
	<WishlistContext.Provider value={props}>{props.children}</WishlistContext.Provider>
);

export const useWishlist = () => {
	const context = useContext(WishlistContext);

	return context;
};

export default WishlistProvider;
